




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";

@Component
export default class InventoryHistoryDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Object, default: null }) product!: any;

  @State("inventoryDetails") inventoryItemsState: any;
  @Action("getInventoryItemsByProduct") getInventoryItemsByProduct: any;

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  @Watch("dialog")
  onDialogChange(newVal: boolean) {
    if (newVal && this.product) {
      this.loadInventoryHistory();
    }
  }

  async loadInventoryHistory() {
    if (this.product && this.product.productId) {
      await this.getInventoryItemsByProduct(this.product.productId);
    }
  }

  closeDialog() {
    this.dialog = false;
  }

  getInventoryHistoryHeaders() {
    return [
      { text: this.$t("INVENTORY_TABLE_INVENTORY"), value: "inventory.description", width: "1%", align: "left" },
      { text: this.$t("INVENTORY_TABLE_ORIGINAL_SITE"), value: "origSite.name", width: "1%", align: "left" },
      { text: this.$t("INVENTORY_TABLE_CURRENT_SITE"), value: "site.name", width: "1%", align: "left" },
      { text: this.$t("INVENTORY_TABLE_USER"), value: "user.userName", width: "1%", align: "left" },
      { text: this.$t("INVENTORY_TABLE_DATE"), value: "createdDate", width: "1%", align: "left" },
      { text: this.$t("INVENTORY_TABLE_NOTE"), value: "note", width: "1%", align: "left" }
    ];
  }

  formatDate(date) {
    if (!date) {
      return "N/A";
    }
    return new Date(date).toLocaleDateString();
  }
}
